/** Ledger accounts (docs/06-db-schema.md section 8): only `platform_fee` holds the platform's own money. */
export const LEDGER_ACCOUNT_KINDS = [
    "buyer_external",
    "escrow_held",
    "seller_account",
    "seller_external",
    "platform_fee",
    "provider_fee",
];
export const JOURNAL_KINDS = [
    "hold",
    "release",
    "refund",
    "reversal",
    "external_offline",
    "provider_fee",
    "adjustment",
];
/** Accounts kept per enterprise; the others are platform-wide, per currency. */
const PER_ENTERPRISE = ["buyer_external", "seller_account", "seller_external"];
/**
 * What is wrong with a journal (PAY-7): at least two lines, each positive, each on an account of the right scope, and
 * debits equal to credits in every currency. The database checks the balance again at commit.
 */
export function journalIssues(lines) {
    const issues = [];
    if (lines.length < 2)
        issues.push("TOO_FEW_LINES");
    const net = new Map();
    lines.forEach((line, index) => {
        if (!line.amount.isPositive())
            issues.push(`lines.${index}:NOT_POSITIVE`);
        const perEnterprise = PER_ENTERPRISE.includes(line.account.kind);
        if (perEnterprise && line.account.tenantId === null)
            issues.push(`lines.${index}:TENANT_REQUIRED`);
        if (!perEnterprise && line.account.tenantId !== null)
            issues.push(`lines.${index}:PLATFORM_ACCOUNT`);
        const signed = line.direction === "debit" ? line.amount.minor : -line.amount.minor;
        net.set(line.amount.currency, (net.get(line.amount.currency) ?? 0n) + signed);
    });
    for (const [currency, balance] of net)
        if (balance !== 0n)
            issues.push(`UNBALANCED:${currency}`);
    return issues;
}
/**
 * A bank transfer the seller confirmed (ADR 0005, PAY-10): the money went from the buyer's bank straight to the
 * seller's, outside Airwallex, so it moves between the two external accounts and never through escrow.
 */
export function externalOfflineLines(input) {
    return [
        {
            account: { kind: "seller_external", tenantId: input.sellerTenantId },
            direction: "debit",
            amount: input.amount,
        },
        {
            account: { kind: "buyer_external", tenantId: input.buyerTenantId },
            direction: "credit",
            amount: input.amount,
        },
    ];
}
//# sourceMappingURL=ledger.js.map